import React, { useState, useEffect } from "react";
const C = { gold:"#C9A84C", goldLight:"#E8D5A0" };

export default function HeroBanner({ banner }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (!banner?.desktopImages?.length) return;
    const t = setInterval(() => setIdx(p => (p + 1) % banner.desktopImages.length), 3500);
    return () => clearInterval(t);
  }, [banner]);

  if (!banner) return null;
  return (
    <section className="cc-hero">
      {banner.desktopImages.map((img, i) => (
        <img key={i} src={`https://api.carnivalcastle.com/${img}`} alt=""
          className="cc-hero-img" style={{ opacity: i === idx ? 1 : 0, zIndex: i === idx ? 1 : 0 }} />
      ))}
      <div className="cc-hero-ovl" style={{ zIndex: 2 }} />
      <div className="cc-hero-cnt">
        <p style={{ fontSize:11, letterSpacing:4, textTransform:"uppercase", color:C.goldLight, marginBottom:12, fontWeight:600 }}>
          ✦ Private Theatre Celebrations ✦
        </p>
        <h1 className="cc-hero-h"
          dangerouslySetInnerHTML={{ __html: banner.title || "Your Special Moment <span>Deserves a Stage</span>" }} />
        <p className="cc-hero-sub">{banner.description || "Book a private theatre — just for you and your loved ones"}</p>
        <div style={{ display:"flex", gap:14, justifyContent:"center", flexWrap:"wrap" }}>
          <a href="/locations" className="cc-btn-gold">🎉 Book Now</a>
          <a href="tel:8977917555" className="cc-btn-outline" style={{ borderColor:"rgba(255,255,255,.5)", color:"#fff" }}>📞 Call to Book</a>
        </div>
      </div>
      <div style={{ position:"absolute", bottom:28, left:"50%", transform:"translateX(-50%)", display:"flex", gap:8, zIndex:3 }}>
        {banner.desktopImages.map((_, i) => (
          <button key={i} className={`cc-hdot${i === idx ? " on" : ""}`} onClick={() => setIdx(i)} />
        ))}
      </div>
    </section>
  );
}